import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TestGenerationLoaderComponent } from './test-generation-loader/test-generation-loader.component';

@NgModule({
	declarations: [TestGenerationLoaderComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatButtonModule,
		MatIconModule,
		MatCardModule,
		MatFormFieldModule,
		MatListModule,
		MatSidenavModule,
		MatToolbarModule,
		MatSelectModule,
		MatMenuModule,
		RouterModule,
		MatProgressSpinnerModule,
	],
	exports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatButtonModule,
		MatIconModule,
		MatCardModule,
		MatFormFieldModule,
		MatListModule,
		MatSidenavModule,
		MatToolbarModule,
		MatSelectModule,
		MatMenuModule,
		RouterModule,
		MatProgressSpinnerModule,
		TestGenerationLoaderComponent
	]
})
export class SharedModule { }